import { render } from "./DeviceItem.vue?vue&type=template&id=2331c48c&scoped=true"
import script from "./DeviceItem.vue?vue&type=script&lang=js"
export * from "./DeviceItem.vue?vue&type=script&lang=js"

import "./DeviceItem.vue?vue&type=style&index=0&id=2331c48c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2331c48c"]])

export default __exports__